const AccountingDocumentArchiveEnum = {
  INVOICE: "INVOICE",
  SETTLEMENT: "SETTLEMENT",
} as const;

export default AccountingDocumentArchiveEnum;
